/** The largest page the server keeps beside an article (lib/kb.mjs HTML_MAX in saas-mcp-service). */
export const HTML_MAX = 300000;
const DROP = 'script,style,noscript,template,svg,canvas,iframe';
const BLOCK = 'p,div,li,h1,h2,h3,h4,h5,h6,tr,section,article,header,footer,table,ul,ol,br,dt,dd,blockquote';

/**
 * The readable text of an uploaded page, which becomes the article body Livy searches and quotes. The page itself is
 * only ever shown in a sandboxed frame; its scripts never run in the app.
 */
export function htmlToText(html) {
  var _doc$querySelector$te, _doc$querySelector, _doc$body$textContent, _doc$body;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const title = (_doc$querySelector$te = (_doc$querySelector = doc.querySelector('title')) === null || _doc$querySelector === void 0 || (_doc$querySelector = _doc$querySelector.textContent) === null || _doc$querySelector === void 0 ? void 0 : _doc$querySelector.trim()) !== null && _doc$querySelector$te !== void 0 ? _doc$querySelector$te : '';
  doc.querySelectorAll(DROP).forEach(el => el.remove());
  // A heading the page fills in with script is empty here: no marker for it.
  doc.querySelectorAll('h1,h2,h3').forEach(el => {
    var _el$textContent;
    return ((_el$textContent = el.textContent) === null || _el$textContent === void 0 ? void 0 : _el$textContent.trim()) && el.prepend('\n## ');
  });
  doc.querySelectorAll('li').forEach(el => el.prepend('- '));
  doc.querySelectorAll(BLOCK).forEach(el => el.append('\n'));
  const text = ((_doc$body$textContent = (_doc$body = doc.body) === null || _doc$body === void 0 ? void 0 : _doc$body.textContent) !== null && _doc$body$textContent !== void 0 ? _doc$body$textContent : '').split('\n').map(line => line.replace(/\s+/g, ' ').trim()).filter((line, i, all) => line || i > 0 && all[i - 1]).join('\n').trim();
  return {
    title,
    text
  };
}
/** A dropped .html, .md or .txt file as article fields; throws with a message the page shows. */
export async function readUpload(file) {
  const base = file.name.replace(/\.[^.]+$/, '');
  // file.size is bytes, which is what the server caps.
  if (/\.html?$/i.test(file.name) && file.size > HTML_MAX) throw new Error("That page is ".concat(Math.round(file.size / 1000), " KB; the limit is 300 KB."));
  const raw = await file.text();
  if (/\.html?$/i.test(file.name)) {
    const _htmlToText = htmlToText(raw),
      title = _htmlToText.title,
      text = _htmlToText.text;
    return {
      title: title || base,
      body: text,
      html: raw
    };
  }
  if (/\.(md|markdown|txt)$/i.test(file.name)) return {
    title: base,
    body: raw
  };
  throw new Error('Upload an .html, .md or .txt file.');
}